import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import {i18n} from '../plugins/vuetify';

Vue.use(VueAxios, Axios);

// Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
// Vue.prototype.$http.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

let axiosInstance = Axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

// Request interceptor — attach current i18n locale as Accept-Language on every API call
axiosInstance.interceptors.request.use(
    request => {
        request.headers['Accept-Language'] = i18n.locale;
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return Promise.reject(error)
    }
);

export default axiosInstance;
